import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import { BsBuildings } from "react-icons/bs";
import { GiArchiveRegister } from "react-icons/gi";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { FaMedal } from "react-icons/fa6";
import { GrCertificate } from "react-icons/gr";
import "./Timeline.css";

const Timeline = (props) => {
  const openGallery = () => {
    props.onOpen();
  };

  return (
    <div
      className="timeline-container"
      style={{ backgroundColor: "#f4f4f4", padding: "50px 0" }}
    >
      <p
        style={{ color: "#ff4081", fontSize: "1.5rem" }}
        className="title-timeline text-uppercase text-center"
      >
        Chặng đường phát triển
      </p>
      <VerticalTimeline lineColor="#ddd">
        <VerticalTimelineElement
          className="vertical-timeline-element-first"
          date="10/2020"
          iconStyle={{ background: "#2196f3", color: "#fff" }}
          icon={<BsBuildings />}
        >
          <h4
            style={{ color: "#2196f3" }}
            className="vertical-timeline-element-title"
          >
            Thành lập Công ty Cổ Phần Thương Mại và Dịch Vụ WMA
          </h4>
          <p>
            Công ty CPTMDV WMA là đơn vị sở hữu thương hiệu Mễ Mễ - một thương
            hiệu Việt chuyên về các dòng sản phẩm dành cho mẹ và bé được nghiên
            cứu và sản xuất riêng cho thị trường Việt Nam.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element-register"
          date="07/2021"
          iconStyle={{ background: "#e91e63", color: "#fff" }}
          icon={<GiArchiveRegister />}
        >
          <h4
            style={{ color: "#e91e63" }}
            className="vertical-timeline-element-title"
          >
            Đăng ký sở hữu trí tuệ với thương hiệu Mễ Mễ tại Việt Nam
          </h4>
          <p>
            07/2021 - Công ty CPTMDV WMA đã gửi hồ sơ tới cục Sở hữu trí tuệ
            Việt Nam để đăng ký sở hữu trí tuệ với thương hiệu Mễ Mễ tại Việt
            Nam.{" "}
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element-certificate"
          date="10/2023"
          iconStyle={{ background: "#10cc52", color: "#fff" }}
          icon={<AiOutlineSafetyCertificate />}
        >
          <h4
            style={{ color: "#10cc52" }}
            className="vertical-timeline-element-title"
          >
            Chứng nhận nhãn hiệu từ cục sở hữu trí tuệ Việt Nam
          </h4>
          <p>
            Sau 2 năm chờ đợi, Mễ Mễ đã chính thức nhận được giấy chứng nhận
            đăng ký nhãn hiệu tại Cục sở hữu Trí tuệ Việt Nam. Đây là một chứng
            nhận quan trọng dành cho thương hiệu Việt, giúp Mễ Mễ khẳng định độc
            quyền thương hiệu trong ngành tã bỉm, sự uy tín tới toàn thể khách
            hàng khi thể hiện sự cam kết chất lượng, nguồn gốc xuất xứ rõ ràng.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element-top20"
          date="12/2023"
          iconStyle={{ background: "#6a1b9a", color: "#fff" }}
          icon={<GrCertificate />}
        >
          <h4
            style={{ color: "#6a1b9a" }}
            className="vertical-timeline-element-title text-capitalize"
          >
            TOP 20 SẢN PHẨM CHẤT LƯỢNG ĐƯỢC NGƯỜI VIỆT TIN DÙNG 2023
          </h4>
          <p>
            12/2023, Mễ Mễ vinh dự đạt danh hiệu “Top 20 sản phẩm chất lượng tốt
            được người Việt tin dùng”, đây là giải thưởng uy tín chỉ dành cho
            các thương hiệu của Việt Nam. Lễ trao giải được phát sóng trực tiếp
            trên truyền hình HN2, nằm trong chuỗi sự kiện “Hàng Việt tốt - Dịch
            vụ hoàn hảo” nhằm chọn ra những thương hiệu lớn, sản phẩm - dịch vụ
            Việt chất lượng.{" "}
            <span
              onClick={openGallery}
              style={{
                backgroundColor: "#6a1b9a",
              }}
            >
              Xem
            </span>
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element-top10"
          date="11/2024"
          iconStyle={{ background: "#fd4f31", color: "#fff" }}
          icon={<FaMedal />}
        >
          <h4
            style={{ color: "#fd4f31" }}
            className="vertical-timeline-element-title"
          >
            TOP 10 THƯƠNG HIỆU UY TÍN QUỐC GIA NĂM 2024
          </h4>
          <p>
            24/11/2024, Mễ Mễ đã chính thức được vinh danh tại “Diễn đàn phát
            triển Thương hiệu uy tín Quốc gia 2024”, được tổ chức bởi Trung tâm
            Công nghệ Chống hàng giả và phát sóng trên đài truyền hình VTC6. Đây
            là một trong những giải thưởng uy tín nhất dành cho các thương hiệu
            Việt Nam.{" "}
            <span
              style={{
                backgroundColor: "#fd4f31",
              }}
            >
              <a
                href="https://memevietnam.com/news/676fd1b308941ed17494eb7f"
                target="_blank"
                rel="noopener noreferrer"
              >
                Xem
              </a>
            </span>
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
};

export default Timeline;
